export default () => ({
    activeSlide: 1,
    totalSlides: 3,

    content: {
        [':class']: 'activeSlide === Number($el.dataset.slide) ? "--is-active" : ""',
    },

    init() {
        setInterval(() => {
            this.next()
        }, 8000)
    },

     next() {
        this.activeSlide = this.activeSlide === this.totalSlides ? 1 : this.activeSlide + 1
    },

    prev() {
        this.activeSlide = this.activeSlide === 1 ? this.totalSlides : this.activeSlide - 1
    }
})
